module.exports = __webpack_public_path__ + "img/image 11 (3).39fb9197.png";